import { css } from '@microsoft/fast-element';
import { focusStrokeOuter, foregroundOnPrimaryFocus, foregroundOnPrimaryHover, neutralForegroundHover, neutralForegroundRest, neutralLayer1, neutralLayer3, neutralStealthFillHover, neutralStealthFillRest, neutralStrokeRest, getToken } from '../../design-tokens';
import { heightNumber } from '../../styles/size';
import { display } from '../../foundation/display';

export const optionStyles = css`
        ${display("inline-flex")} :host {
            position: relative;
            font-family: ${getToken('typography-font-family')};
            background: ${neutralStealthFillRest};
            border: calc(${getToken('space-stroke-width')} * 1px) solid ${neutralLayer1};
            box-sizing: border-box;
            color: ${neutralForegroundRest};
            cursor: pointer;
            flex: 0 0 auto;
            fill: currentcolor;
            font-size: ${getToken('typography-control-font-size')};
            min-height: calc(${heightNumber} * 1px);
            line-height: ${getToken('typography-control-line-height')};
            outline: none;
            overflow: hidden;
            align-items: center;
            padding: 0 1ch;
            user-select: none;
        }

        :host(:not([disabled]):hover),
        :host(:not([disabled]):not([aria-selected="true"]):hover) {
            background: ${neutralStealthFillHover};
            color: ${neutralForegroundHover};
        }

        :host(:not([disabled]):active),
        :host(:not([disabled]):not([aria-selected='true']):active),
        :host([aria-selected="true"]),
        :host(:not([disabled])[aria-selected="true"]:hover),
        :host(:not([disabled])[aria-selected="true"]:active) {
            background: ${getToken('color-primary-hover')};
            border-color: ${getToken('color-primary-hover')};
            color: ${foregroundOnPrimaryHover};
        }

        :host(:focus-visible) {
            border-color: ${focusStrokeOuter};
        }

        :host([disabled]) {
            cursor: not-allowed;
            opacity: ${getToken('color-disabled-opacity')};
        }

        .content {
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .start,
        .end,
        ::slotted(svg) {
            display: flex;
        }

        ::slotted([slot="end"]) {
            margin-inline-start: 1ch;
        }

        ::slotted([slot="start"]) {
            margin-inline-end: 1ch;
        }

        :host([aria-checked="true"][aria-selected="false"]) {
            border-color: ${neutralStrokeRest};
            background: ${neutralLayer3};
            color: ${neutralForegroundRest};
        }

        :host([aria-checked="true"][aria-selected="false"]:not([disabled]):hover) {
            background: ${getToken('color-neutral-hover')};
        }

        :host([aria-checked="true"][aria-selected="true"]) {
            border-color: ${focusStrokeOuter};
            background: ${getToken('color-primary-focus')};
            color: ${foregroundOnPrimaryFocus};
        }

        :host([aria-checked="true"][aria-selected="true"]:hover) {
            background: ${getToken('color-primary-hover')};
            color: ${foregroundOnPrimaryHover};
        }
  `;
